<template>
  <div class="problem-tab tab">
    <div
      class="tab-title"
      v-text="'Quel est le type de problème rencontré ?'"
    />
    <div class="choice-container">
      <div
        v-for="choice in state.problems"
        :key="choice.id"
        class="choice"
        @click="emits('next', choice)"
      >
        <div class="round-icon">
          <i class="bi" :class="choice.icon" />
        </div>
        <div class="choice-name" v-text="choice.name" />
        <p v-text="choice.description" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["next"]);

const state = reactive({
  problems: [
    {
      id: "1",
      icon: "bi-clock-history",
      name: "L'évaluation de ce participant n'avance pas",
      description:
        "Plus de réponse de ce participant, problème rencontré par ce participant…",
    },
    {
      id: "2",
      icon: "bi-person-slash",
      name: "Ce participant ne devrait pas être activé",
      description:
        "Ce participant a été activé par erreur, je ne souhaite plus évaluer ce participant…",
    },
  ],
});
</script>
